import type { Config } from '/#/config'

export const useSettings = (): Readonly<Config> => {
  const {
    VITE_API_BASE_URL,
    BASE_URL,
    VITE_SENTRY_DSN,
    MODE,
    VITE_GTAG_ID,
    VITE_GTM_ID,
    VITE_POSTHOG_API_KEY,
    VITE_POSTHOG_HOST,
    VITE_MSW_ENABLED,
  } = import.meta.env

  // Take global configuration
  const settings: Readonly<Config> = {
    apiUrl: VITE_API_BASE_URL,
    appUrl: BASE_URL,
    mode: MODE,
    sentryDsn: VITE_SENTRY_DSN,
    gTagId: VITE_GTAG_ID,
    gtmId: VITE_GTM_ID,
    posthogApiKey: VITE_POSTHOG_API_KEY,
    posthogHost: VITE_POSTHOG_HOST,
    mswEnabled: VITE_MSW_ENABLED,
  }
  return settings as Readonly<Config>
}
